import type { AlimentoMacronutriente } from '../types/database'

/** Alimento vinculado a um produto na Tabela de Preços. */
export function alimentoComTabelaPrecos(a: AlimentoMacronutriente | undefined | null): boolean {
  return !!a?.produto_id
}

export function filtrarAlimentosTabelaPrecos(
  alimentos: AlimentoMacronutriente[],
): AlimentoMacronutriente[] {
  return alimentos.filter(alimentoComTabelaPrecos)
}

/** Alimentos referenciados sem vínculo com a Tabela de Preços. */
export function alimentosSemTabelaPrecos(
  alimentoIds: Iterable<string>,
  alimentosById: Map<string, AlimentoMacronutriente>,
): AlimentoMacronutriente[] {
  const seen = new Set<string>()
  const out: AlimentoMacronutriente[] = []
  for (const id of alimentoIds) {
    if (!id || seen.has(id)) continue
    const alimento = alimentosById.get(id)
    if (alimento && !alimentoComTabelaPrecos(alimento)) {
      seen.add(id)
      out.push(alimento)
    }
  }
  return out
}

/** Catálogo para select: itens com preço + seleção legada atual (somente leitura). */
export function opcoesAlimentoFicha(
  catalogo: AlimentoMacronutriente[],
  alimentoIdAtual: string,
  alimentosById: Map<string, AlimentoMacronutriente>,
): AlimentoMacronutriente[] {
  const ids = new Set(catalogo.map((a) => a.id))
  const atual = alimentoIdAtual ? alimentosById.get(alimentoIdAtual) : undefined
  if (atual && !ids.has(atual.id)) return [...catalogo, atual]
  return catalogo
}

export function mensagemAlimentosIndisponiveis(nomes: string[]): string {
  if (!nomes.length) return ''
  const lista = nomes.join(', ')
  return nomes.length === 1
    ? `O alimento "${lista}" não está disponível na Tabela de Preços. Vincule um produto em Macronutrientes ou substitua o item.`
    : `Os seguintes alimentos não estão disponíveis na Tabela de Preços: ${lista}. Vincule produtos em Macronutrientes ou substitua os itens.`
}
